import {
  type ChunkSavedEvent,
  assembleBlob as assembleBlobReal,
  clearBuffers as clearBuffersReal,
  getChunkStats as getChunkStatsReal,
  hasChunks as hasChunksReal,
  purgeExpired as purgeExpiredReal,
  saveChunk as saveChunkReal,
} from "@nudge-ai/audio-store";
import { USE_INDEXEDDB_BACKUP } from "./constants";

export const saveChunk = async (
  audioId: string,
  blob: Blob,
  mimeType: string,
): Promise<ChunkSavedEvent | undefined> => {
  if (!USE_INDEXEDDB_BACKUP) return undefined;
  return saveChunkReal(audioId, blob, mimeType);
};

export const assembleBlob = async (audioId: string): Promise<Blob | null> => {
  if (!USE_INDEXEDDB_BACKUP) return null;
  return assembleBlobReal(audioId);
};

export const clearBuffers = async (audioId: string): Promise<void> => {
  if (!USE_INDEXEDDB_BACKUP) return;
  return clearBuffersReal(audioId);
};

export const purgeExpired = async (days: number): Promise<void> => {
  if (!USE_INDEXEDDB_BACKUP) return;
  return purgeExpiredReal(days);
};

export const getChunkStats = async (audioId: string): Promise<{ count: number; totalBytes: number } | null> => {
  if (!USE_INDEXEDDB_BACKUP) return null;
  return getChunkStatsReal(audioId);
};

export const hasChunks = async (audioId: string): Promise<boolean> => {
  if (!USE_INDEXEDDB_BACKUP) return false;
  return hasChunksReal(audioId);
};
